<template>
    <div>
        <div class="container-fluid">
            <head-block v-if="resources !== null && resources.about" id="about" v-bind:model="resources.about"/>
            <video-block v-if="resources !== null && resources.about" v-bind:model="resources.about"/>
            <process-block v-if="resources !== null && resources.process" id="process" v-bind:model="resources.process"/>
            <portfolio-block v-if="resources !== null && resources.portfolio" id="portfolio" v-bind:model="resources.portfolio"/>
            <awards-block v-if="resources !== null && resources.awards" id="awards" v-bind:model="resources.awards"/>
        </div>
        <contacts-block v-if="resources !== null && resources.contacts" id="contacts" v-bind:model="resources.contacts"/>
        <!--<div class="container-fluid">
            <open-block id="open" v-if="$route.query.openBlock" v-bind:model="resources.open"/>
            <jobs-block id="jobs" v-if="$route.query.jobsBlock" v-bind:model="resources.jobs"/>
            <div class="footer">
                <div class="footer__copy">&copy;2017&nbsp;Museum&nbsp;Architect</div>
            </div>
        </div>-->
    </div>
</template>

<script>
    import HeadBlock from '@/components/home-page-components/HeadBlock'
    import ProcessBlock from '@/components/home-page-components/ProcessBlock'
    import VideoBlock from '@/components/home-page-components/VideoBlock'
    import PortfolioBlock from '@/components/home-page-components/PortfolioBlock'
    import AwardsBlock from '@/components/home-page-components/AwardsBlock'
    import ContactsBlock from '@/components/home-page-components/ContactsBlock'
    import OpenBlock from '@/components/home-page-components/OpenBlock'
    import JobsBlock from '@/components/home-page-components/JobsBlock'

    export default {
        components: {
            HeadBlock,
            VideoBlock,
            ProcessBlock,
            PortfolioBlock,
            AwardsBlock,
            ContactsBlock,
            OpenBlock,
            JobsBlock
        },
        computed: {
            resources () {
                return this.$store.state.resources
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/HomePage.vue